import React from 'react';
import { Modal } from '@increasecard/typed-components';

type CreateReportModalProps = {
  description: string;
  headerText: string;
  onCreateReport: () => void;
  visible: boolean;
  onCancel: () => void;
  onClose: () => void;
  okLabel: string;
};

export function CreateReportModal({
  description,
  headerText,
  onCreateReport,
  visible,
  onCancel,
  onClose,
  okLabel
}: CreateReportModalProps) {
  const handleOkClick = () => {
    onCreateReport();
    onClose();
  };
  return (
    <Modal
      align="center"
      description={description}
      headerText={headerText}
      okLabel={okLabel}
      onCancel={onCancel}
      onClose={onClose}
      onOk={handleOkClick}
      visible={visible}
      width="576"
    />
  );
}
